import React, {Component} from 'react'
import Link from 'gatsby-link'
import {BackgroundReel} from './../components/BackgroundReel/background-reel'
import {Header} from '../components/Header'
import './index.css'
import logoSrc from '../../static/logo_white.png'

import locale from '../locale'
import en from '../data-en'
import cn from '../data-cn'
let data = { en, cn };
let localizedData = () => data[locale.getLocale()];
let home_page = localizedData().home_page;

class IndexPage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mouseOverHeader: false,
    }

    this.mouseOverHeader = this.mouseOverHeader.bind(this);
    this.mouseOffHeader = this.mouseOffHeader.bind(this);
  }

  mouseOverHeader () {
    this.setState({mouseOverHeader : true});
  }

  mouseOffHeader () {
    this.setState({mouseOverHeader : false});
  }

  render() {
    let sizes = [
      this.props.data.inauguralSeasonImage.sizes,
      this.props.data.chamberSeriesImage.sizes
    ];

    return (
      <div>

        <Header
          src={logoSrc}
          data={localizedData().header}
          mouseOffHeader = {this.mouseOffHeader}
          mouseOverHeader = {this.mouseOverHeader}>
        </Header>

        <BackgroundReel
          backgrounds = {home_page.backgrounds}
          isBackgroundDarkened = {this.state.mouseOverHeader}
          areSlidesClickable = {true}
          sizes = {sizes}>
        </BackgroundReel>

      </div>
    );
  }
}

export default IndexPage

export const pageQuery = graphql`
  query IndexQuery {
    chamberSeriesImage: imageSharp(id: { regex: "/2018-chamber-series/" }) {
      sizes(maxWidth: 2000, quality: 100) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    inauguralSeasonImage: imageSharp(id: { regex: "/2017-inaugural-season/" }) {
      sizes(maxWidth: 2000, quality: 100) {
        ...GatsbyImageSharpSizes_noBase64
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js